import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Import react-i18next
import './App.css';

function App() {
  const { t, i18n } = useTranslation(); // Initialize translation functions

  // Function to change language
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="app-container d-flex flex-column min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <Link className="navbar-brand" to="/">{t('footer_brand')}</Link> {/* Translated Brand */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">{t('home')}</Link> {/* Translated */}
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">{t('about')}</Link> {/* Translated */}
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">{t('contact')}</Link> {/* Translated */}
              </li>
            </ul>
            {/* Language Selector */}
            <div className="ms-3">
              <label htmlFor="language-selector" className="text-light me-2">
                {t('select_language')} {/* Translated Label */}
              </label>
              <select
                id="language-selector"
                className="form-select"
                onChange={(e) => changeLanguage(e.target.value)}
                value={i18n.language} // Reflect the current language
              >
                <option value="sh">ChiShona</option>
                <option value="de">Deutsch</option>
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="fr">Français</option>
                <option value="nd">IsiNdebele</option>
              </select>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container mt-4 flex-grow-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-light py-4 mt-4">
        <div className="container">
          <div className="row text-center">
            {/* Column 1 */}
            <div className="col-md-4 mb-3">
              <h5>{t('footer_brand')}</h5> {/* Translated */}
              <p>{t('footer_desc')}</p> {/* Translated */}
            </div>

            {/* Column 2 */}
            <div className="col-md-4 mb-3">
              <h5>{t('quick_links')}</h5> {/* Translated */}
              <ul className="list-unstyled">
                <li><Link className="text-decoration-none" to="/">{t('home')}</Link></li> {/* Translated */}
                <li><Link className="text-decoration-none" to="/about">{t('about')}</Link></li> {/* Translated */}
                <li><Link className="text-decoration-none" to="/contact">{t('contact')}</Link></li> {/* Translated */}
              </ul>
            </div>

            {/* Column 3 */}
            <div className="col-md-4 mb-3">
              <h5>{t('contact_us')}</h5> {/* Translated */}
              <p>
                <i className="fab fa-whatsapp"></i>{" "}
                <a href="tel:+263715112658">+263 715 112 658</a>
              </p>
            </div>
          </div>
          <hr />
          <p className="mt-3 text-center">
            &copy; {new Date().getFullYear()} Amber Fresh. {t('all_rights_reserved')}
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;

